import { useState } from "react";
import { ClipboardList, Loader2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "@/components/ui/sonner";
import { streamStaffAi } from "@/utils/aiStream";

const services = [
  ["family-petition", "Family petition"],
  ["adjustment-status", "Adjustment of status"],
  ["citizenship", "Citizenship / naturalization"],
  ["nvc-consular", "NVC / consular processing"],
  ["translation", "Certified translation"],
  ["other", "Other immigration support"],
];

export const ChecklistAssistant = () => {
  const [service, setService] = useState("family-petition");
  const [output, setOutput] = useState("");
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    setLoading(true);
    setOutput("");
    try {
      await streamStaffAi("/staff/ai/document-checklist", { service }, setOutput);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mt-6 rounded-lg bg-brand-navy p-6 text-white shadow-editorial" data-testid="ai-checklist-assistant">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="overline text-brand-copper">GPT 5.4 Staff Tool</p>
          <h2 className="mt-2 flex items-center gap-3 font-serif text-2xl font-bold">
            <ClipboardList className="h-6 w-6 text-brand-copper" /> AI Document Checklist Assistant
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-7 text-white/65">
            Generate a service-specific preparation checklist for staff review. Always verify requirements before advising a client.
          </p>
        </div>
        <div className="grid gap-3 sm:grid-cols-[260px_auto]">
          <Select value={service} onValueChange={setService}>
            <SelectTrigger data-testid="checklist-service-select" className="h-12 border-white/15 bg-slate-800 text-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {services.map(([value, label]) => <SelectItem key={value} value={value} data-testid={`checklist-service-${value}`}>{label}</SelectItem>)}
            </SelectContent>
          </Select>
          <Button onClick={generate} disabled={loading} data-testid="generate-checklist-button" className="h-12 rounded-full bg-brand-copper text-brand-navy hover:bg-brand-copper/90">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Sparkles className="h-4 w-4" />}
            Generate Checklist
          </Button>
        </div>
      </div>
      {output && (
        <div className="mt-6 rounded-lg bg-white/[0.07] p-5 text-sm leading-7 text-white/82 whitespace-pre-wrap" data-testid="checklist-ai-output">
          {output}
        </div>
      )}
      <p className="mt-5 text-xs leading-5 text-white/48">
        Egaal Tax & Immigration Services provides document preparation and administrative support, not legal advice or representation.
      </p>
    </section>
  );
};
